import { Button } from "@/shared/components/shadcn/Button";
import { InitialsAvatar } from "@/shared/components/ui/InitialsAvatar";

interface DashboardIdentityProps {
  businessName: string;
  locationName: string;
  onBook: () => void;
}

export function DashboardIdentity({ businessName, locationName, onBook }: DashboardIdentityProps) {
  const [firstWord = "", secondWord = ""] = businessName.trim().split(/\s+/);

  return (
    <div className="flex items-center gap-2.5">
      <div aria-hidden="true" className="shrink-0">
        <InitialsAvatar firstName={firstWord} lastName={secondWord} size={30} />
      </div>
      <div className="min-w-0 flex-1">
        <p className="truncate text-xs font-bold" title={businessName}>{businessName}</p>
        <p className="mt-0.5 truncate text-[11px] text-muted-foreground" title={locationName}>{locationName}</p>
      </div>
      <Button className="h-11 shrink-0 py-2" onClick={onBook}>Book</Button>
    </div>
  );
}
